module.exports = __webpack_public_path__ + "static/based-segmentation-3-236753c2a0693680075413e1d6910ce5.png";